const th = {
  meta: {
    title: 'Agathit Domrongwatanagoon, CTO และ Full Stack Developer',
    description:
      'Agathit Domrongwatanagoon, CTO และ Full Stack Developer ในกรุงเทพฯ ผู้ก่อตั้ง FindBack และหัวหน้าทีม Digital Transformation ของ Somchai Aluminium และ SAG All Color',
  },
  ui: {
    nav: { work: 'ผลงาน', career: 'ประสบการณ์', skills: 'ทักษะ', about: 'เกี่ยวกับ' },
    mainNav: 'เมนูหลัก',
    language: 'ภาษา',
    openMenu: 'เปิดเมนู',
    closeMenu: 'ปิดเมนู',
    emailMe: 'ส่งอีเมล',
    seeWork: 'ดูผลงาน',
    copyEmail: 'คัดลอกอีเมล',
    emailCopied: 'คัดลอกอีเมลแล้ว',
    highlights: 'จุดเด่น',
    filterLabel: 'กรองผลงานตามประเภท',
    techUsed: 'เทคโนโลยีที่ใช้',
    visit: 'เข้าชม',
    showDetails: 'ดูรายละเอียด',
    hideDetails: 'ซ่อนรายละเอียด',
    showAllProjects: (count) => `ดูผลงานทั้งหมด ${count} ชิ้น`,
    showFewerProjects: 'แสดงน้อยลง',
    headings: {
      work: 'ผลงานที่คัดมา',
      career: 'เส้นทางการทำงาน',
      skills: 'เครื่องมือที่ใช้',
      about: 'นอกเหนือจากงาน',
      contact: 'หาคนร่วมทีม หรือมีโปรเจกต์? อีเมลมาได้เลย',
    },
    education: 'การศึกษา',
    activities: 'กิจกรรม',
    interests: 'ความสนใจ',
    signal: {
      aria: 'สัญญาณที่เริ่มจากคลื่น analog แล้วถูกแปลงเป็นค่า digital',
      analog: 'สัญญาณ analog',
      sampled: (bits, levels) => `สุ่มค่าที่ ${bits} บิต ${levels} ระดับ`,
      hint: 'เลื่อนไปบนสัญญาณเพื่อย้ายจุดสุ่มค่า เลื่อนขึ้นเพื่อเพิ่มจำนวนบิต',
    },
  },
  person: {
    location: 'กรุงเทพมหานคร ประเทศไทย',
    intro:
      'ผมเปลี่ยนงานที่ทำด้วยมือให้เป็นซอฟต์แวร์ที่พนักงานใช้จริงทุกวัน และดูแลให้ระบบทำงานได้ต่อเนื่อง ปัจจุบันเป็น CTO ของ Software Marketplace ผู้ก่อตั้ง FindBack และหัวหน้าทีม Digital Transformation ของ Somchai Aluminium และ SAG All Color',
  },
  proof: {
    lead: 'Western Digital นำซอฟต์แวร์ตรวจจับสิ่งปนเปื้อนของผมไปใช้จริง และยื่นจดสิทธิบัตร',
    supporting: [
      'CTO และวิศวกรคนเดียวของ Software Marketplace ซึ่งเป็น startup ระยะเริ่มต้น และผู้ก่อตั้ง FindBack แพลตฟอร์มประกาศของหายได้คืนที่ใช้ฟรีทั่วไทย',
      'หัวหน้าทีม Digital Transformation ของ Somchai Aluminium และ SAG All Color รับผิดชอบออกแบบ ติดตั้ง และดูแลระบบภายในทั้งหมด',
      'ก่อนหน้านี้พัฒนาซอฟต์แวร์ให้ Pizza Hut Thailand และ NXP Semiconductors',
    ],
  },
  filters: { all: 'ทั้งหมด', web: 'เว็บแพลตฟอร์ม', ai: 'AI และ machine vision' },
  projects: {
    mesa: {
      title: 'ระบบตรวจจับอนุภาค MESA Density',
      place: 'Western Digital',
      summary:
        'ซอฟต์แวร์ประมวลผลภาพที่ตรวจหาสิ่งปนเปื้อนขนาดเล็กบนแผ่นฮาร์ดดิสก์ Western Digital นำไปใช้จริงและยื่นจดสิทธิบัตร',
      details:
        'พัฒนาอัลกอริทึมตรวจจับสิ่งปนเปื้อนบนฮาร์ดดิสก์ให้แม่นยำขึ้นด้วยเทคนิคการประมวลผลภาพ และสร้างโปรแกรมบนเดสก์ท็อปที่ช่างเทคนิคใช้งานได้ง่าย Western Digital นำผลงานไปใช้จริงและยื่นจดสิทธิบัตร',
    },
    'project-quotation': {
      title: 'ระบบบริหารโครงการและใบเสนอราคา',
      place: 'Somchai Aluminium',
      summary:
        'ดูแลงานเอกสารการขายของธุรกิจอลูมิเนียมและกระจก ตั้งแต่ใบเสนอราคาจนถึงใบส่งของ พนักงานใช้งานทุกวัน',
      details:
        'ครอบคลุมข้อมูลลูกค้า ใบเสนอราคาหลาย revision การคิด markup ค่าคอมมิชชันและส่วนลด การอนุมัติ โครงการ ใบแจ้งหนี้ การบันทึกรับชำระ และใบส่งของ เอกสารถูกสร้างเป็น PDF ขนาด A4 ที่ฝั่ง server และออกใบเสนอราคาได้ 3 ภาษา คือไทย จีน และอังกฤษ กำหนดสิทธิ์ตามบทบาทและมี audit log ผมเป็นผู้ออกแบบ ติดตั้ง และดูแลระบบที่ใช้งานจริง',
    },
    findback: {
      title: 'FindBack',
      place: 'ผู้ก่อตั้ง',
      summary: 'แพลตฟอร์มประกาศและค้นหาของหายได้คืนทั่วประเทศไทย ใช้ฟรี พร้อมแผนที่แสดงประกาศ',
      details:
        'ผู้ใช้ประกาศของที่ทำหายหรือเก็บได้ตามหมวดหมู่ เช่น กระเป๋าสตางค์ โทรศัพท์ กุญแจ เอกสาร สัตว์เลี้ยง และยานพาหนะ แล้วดูประกาศบนแผนที่ได้ ใช้งานฟรี ผมเป็นเจ้าของและผู้ดูแลบริการนี้',
    },
    'self-hosted-platform': {
      title: 'แพลตฟอร์ม self-hosted สำหรับเว็บแอป 6 ระบบ',
      place: 'Somchai Aluminium และ SAG All Color',
      summary:
        'Ubuntu server เครื่องเดียวที่รันเว็บแอป 6 ระบบบน Docker หลัง Nginx และ Cloudflare พร้อมสำรองฐานข้อมูลทุกคืน',
      details:
        'แยก production, demo, ฐานข้อมูล และ reverse proxy ออกเป็น Docker network ของตัวเอง ทุกครั้งที่ deploy ทำตามขั้นตอนที่เขียนไว้และทำซ้ำได้ คือสำรองฐานข้อมูลและ image รัน migration ตรวจผล และมีทางถอยกลับเสมอ ทราฟฟิกเว็บเข้าถึง server ผ่าน Cloudflare เท่านั้น ฐานข้อมูลไม่เปิดออกอินเทอร์เน็ต และการเข้าถึงจากออฟฟิศผ่าน WireGuard VPN',
    },
    central: {
      title: 'เว็บแพลตฟอร์ม Central ของ Pizza Hut',
      place: 'PH Capital (Pizza Hut)',
      summary: 'แพลตฟอร์มปฏิบัติการภายในสำหรับคูปอง การจัดการสาขา ข้อมูลพนักงาน และข้อมูลลูกค้า',
      details:
        'พัฒนาและดูแลแพลตฟอร์มปฏิบัติการภายในสำหรับคูปอง การจัดการสาขา ข้อมูลพนักงาน และข้อมูลลูกค้า ฝั่ง frontend ใช้ React ฝั่ง backend เป็น API บน Express.js กับฐานข้อมูล MSSQL และจัดโครงสร้าง backend เป็นชั้น Controller / Router / Service',
    },
    'lot-status': {
      title: 'ระบบติดตามสถานะ Lot',
      place: 'NXP Semiconductors',
      summary: 'ติดตาม lot ของเซมิคอนดักเตอร์ตลอดกระบวนการผลิต พร้อม dashboard ข้อมูลการผลิตแบบ real-time',
      details:
        'พัฒนาระบบติดตามสำหรับการผลิตเซมิคอนดักเตอร์ที่ NXP ด้วย Angular (frontend), C#/.NET (backend) และ MSSQL และสร้าง dashboard แบบ real-time ด้วย Kibana, Elasticsearch (ELK Stack) และ Grafana เพื่อแสดงข้อมูลการผลิต',
    },
    'predictive-maintenance': {
      title: 'Predictive Maintenance ด้วย Machine Learning',
      place: 'NXP Semiconductors',
      summary: 'โมเดล machine learning ที่ทำนายว่าเครื่องจักรผลิตเซมิคอนดักเตอร์จะต้องซ่อมบำรุงเมื่อไร',
      details:
        'เป็นผู้นำโครงการ FabKey Predictive Maintenance ที่ NXP ด้วย Python โดยใช้โมเดล Logistic Regression, KNN, Decision Tree, SVM และ Ensemble เพื่อทำนายการซ่อมบำรุงเครื่องจักรผลิตเซมิคอนดักเตอร์',
    },
    'glass-production-tracking': {
      title: 'ระบบติดตามการผลิตกระจก',
      place: 'Somchai Aluminium',
      summary:
        'ติดตามกระจกแต่ละแผ่นผ่านสถานีผลิตด้วยการสแกนบาร์โค้ดจากกล้องมือถือ อยู่ระหว่างให้พนักงานทดสอบ',
      details:
        'ผู้ปฏิบัติงานสแกนบาร์โค้ดที่แต่ละสถานีด้วยกล้องมือถือ และทุกหน้าจออัปเดตแบบ real-time ผ่าน WebSocket อุปกรณ์ถูกจับคู่กับสถานี และผู้ปฏิบัติงานเข้าใช้ด้วย PIN ระบบติดตั้งแล้วและอยู่ระหว่างให้พนักงานทดสอบ ยังไม่ได้ใช้งานจริง',
    },
    'pricing-calculator': {
      title: 'ระบบคำนวณราคางานอลูมิเนียมและกระจก',
      place: 'Somchai Aluminium',
      summary: 'คำนวณราคางานจาก template หน้าตัด และรายการวัสดุ (BOM) อยู่ระหว่างให้พนักงานทดสอบ',
      details:
        'คำนวณราคางานอลูมิเนียมและกระจกจาก template สินค้า หน้าตัดโปรไฟล์ และรายการวัสดุ ระบบติดตั้งแล้วและอยู่ระหว่างให้พนักงานทดสอบ ยังไม่ได้ใช้งานจริง',
    },
    'line-ordering': {
      title: 'เชื่อมต่อ LINE สำหรับสั่งอาหาร',
      place: 'PH Capital (Pizza Hut)',
      summary: 'ระบบสั่งอาหารและตอบลูกค้าอัตโนมัติผ่าน LINE Official Account',
      details:
        'เชื่อมต่อกับ LINE Official Account เพื่อสั่งอาหารและตอบลูกค้าอัตโนมัติผ่าน LINE Messaging API และสร้างเครื่องมือบนเว็บสำหรับเก็บแบบสำรวจ รายงานการติดต่อ และ deploy WordPress อัตโนมัติ',
    },
    'fpga-rl': {
      title: 'Reinforcement Learning บน FPGA',
      place: null,
      summary: 'Q-learning ที่ทำเป็นวงจรดิจิทัลบน FPGA เขียนด้วย VHDL',
      details:
        'ออกแบบวงจรดิจิทัลบน FPGA เพื่อรันอัลกอริทึม Q-learning ด้วย VHDL โดยปรับให้ทำงานได้ดีบนฮาร์ดแวร์ สร้างสภาพแวดล้อมทดสอบด้วย OpenAI Gym เพื่อตรวจสอบกับโจทย์การตัดสินใจ และนำแนวคิด reinforcement learning มาใช้กับการเร่งความเร็วด้วยฮาร์ดแวร์',
    },
  },
  experiences: [
    {
      id: 'software-marketplace',
      company: 'Software Marketplace',
      role: 'Chief Technology Officer',
      period: 'ปัจจุบัน',
      description:
        'เป็นวิศวกรคนเดียวของ startup ระยะเริ่มต้นที่ทำ software marketplace รับผิดชอบผลิตภัณฑ์ทั้งหมด ตั้งแต่สถาปัตยกรรม การพัฒนา การ deploy ไปจนถึงการดูแลระบบ',
      achievements: [],
    },
    {
      id: 'findback',
      company: 'FindBack (findbacktech.com)',
      role: 'ผู้ก่อตั้ง',
      period: 'ปัจจุบัน',
      description: 'เจ้าของและผู้ดูแล FindBack แพลตฟอร์มประกาศและค้นหาของหายได้คืนที่ใช้ฟรีทั่วประเทศไทย',
      achievements: [],
    },
    {
      id: 'somchai-sag',
      company: 'Somchai Aluminium Co., Ltd. และ บริษัท เอส เอ จี ออล คัลเลอร์ จำกัด',
      role: 'Team Lead, Digital Transformation',
      period: 'ปัจจุบัน',
      description:
        'นำงาน Digital Transformation ให้ผู้ผลิตอลูมิเนียมและกระจก และบริษัทพ่นสีฝุ่นในเครือ โดยออกแบบระบบภายใน ติดตั้ง และดูแลให้ใช้งานได้ต่อเนื่อง',
      achievements: [
        'นำระบบบริหารโครงการและใบเสนอราคาขึ้นใช้งานจริงทุกวัน ครอบคลุมใบเสนอราคา การอนุมัติ ใบแจ้งหนี้ การรับชำระ และใบส่งของ รองรับภาษาไทย จีน และอังกฤษ',
        'ตั้ง server แบบ self-hosted เครื่องเดียวที่รันเว็บแอป 6 ระบบบน Docker หลัง Nginx และ Cloudflare พร้อมสำรองข้อมูลทุกคืนและขั้นตอน deploy ที่ทำซ้ำได้',
        'ติดตั้งระบบติดตามการผลิตกระจกและระบบคำนวณราคา ซึ่งอยู่ระหว่างให้พนักงานทดสอบ',
        'กำลังย้ายงานคลังสินค้าและจัดซื้อจาก AppSheet และ Google Sheets มาเป็นระบบที่พัฒนาเอง',
      ],
    },
    {
      id: 'ph-capital',
      company: 'PH Capital (Pizza Hut)',
      role: 'Senior Software Developer',
      period: 'ก.พ. 2024 ถึง ก.ค. 2025',
      description:
        'นำการพัฒนาเว็บแอปพลิเคชันและเครื่องมือภายในสำหรับงานปฏิบัติการของ Pizza Hut Thailand และเป็นพี่เลี้ยงให้ developer รุ่นน้อง',
      achievements: [
        "พัฒนาและดูแลเว็บแพลตฟอร์ม 'Central' สำหรับงานปฏิบัติการภายใน ได้แก่ คูปอง การจัดการสาขา ข้อมูลพนักงาน และข้อมูลลูกค้า",
        'พัฒนา frontend ด้วย React และ backend API ด้วย Express.js กับฐานข้อมูล MSSQL',
        'จัดโครงสร้าง backend แยกเป็นชั้น Controller / Router / Service อย่างชัดเจน',
        'เชื่อมต่อ LINE Official Account เพื่อสั่งอาหารและตอบลูกค้าอัตโนมัติผ่าน LINE Messaging API',
        'สร้างเครื่องมือบนเว็บสำหรับเก็บแบบสำรวจ รายงานการติดต่อ และ deploy WordPress อัตโนมัติ',
      ],
    },
    {
      id: 'nxp',
      company: 'NXP Semiconductors',
      role: 'Software Engineer',
      period: 'ม.ค. 2023 ถึง ม.ค. 2024',
      description:
        'พัฒนาซอฟต์แวร์ระดับองค์กรสำหรับการผลิตและทดสอบเซมิคอนดักเตอร์ ทำงานร่วมกับทีมข้ามสายงานเพื่อสร้างระบบประกันคุณภาพและระบบติดตามการผลิต',
      achievements: [
        'พัฒนาระบบติดตามสถานะ lot ด้วย Angular (frontend), C#/.NET (backend) และ MSSQL',
        'สร้าง dashboard แบบ real-time ด้วย Kibana, Elasticsearch (ELK Stack) และ Grafana เพื่อแสดงข้อมูลการผลิต',
        'ใช้ Docker ในการ containerize แอปพลิเคชันและบริการต่าง ๆ',
        'นำโครงการ FabKey Predictive Maintenance ด้วย Python โดยใช้โมเดล Logistic Regression, KNN, Decision Tree, SVM และ Ensemble',
      ],
    },
    {
      id: 'western-digital',
      company: 'Western Digital Storage',
      role: 'Software Engineer Intern',
      period: 'พ.ค. 2022 ถึง ม.ค. 2023',
      description:
        'ร่วมปรับปรุงอัลกอริทึมประมวลผลภาพสำหรับตรวจจับสิ่งปนเปื้อนบนฮาร์ดดิสก์ และพัฒนาโปรแกรมบนเดสก์ท็อปสำหรับวิศวกรและช่างเทคนิค',
      achievements: [
        'สร้างซอฟต์แวร์บนเดสก์ท็อปสำหรับตรวจจับสิ่งปนเปื้อนขนาดเล็กบนแผ่นฮาร์ดดิสก์ด้วย Python และ OpenCV',
        'ลดการแจ้งเตือนผิดพลาดด้วยเทคนิคการกรองภาพและการแยกสัญญาณที่ดีขึ้น',
        'เชื่อมต่อ frontend ที่เขียนด้วย C# ให้ผู้ใช้ทำงานกับระบบตรวจจับได้',
        'บริษัทนำผลงานไปใช้จริงและยื่นจดสิทธิบัตร',
      ],
    },
  ],
  skillGroups: {
    frontend: 'Frontend',
    backend: 'Backend',
    data: 'ข้อมูล',
    infrastructure: 'Infrastructure',
    ai: 'AI และ machine vision',
    hardware: 'ฮาร์ดแวร์',
    markets: 'เครื่องมือเทรด',
  },
  markets: {
    title: 'การเทรดและตลาดการเงิน',
    lead: 'ผมเทรดทั้ง CFD และหุ้น และเขียนเครื่องมือเทรดใช้เอง',
    points: [
      { term: 'Price action', text: 'อ่านพฤติกรรมราคาจากกราฟโดยตรง ใช้ pin bar เป็นสัญญาณหลัก' },
      {
        term: 'Market microstructure',
        text: 'เข้าใจว่าสภาพคล่องและ order flow ขับราคาอย่างไร รวมถึงการกวาด stop และ liquidity sweep',
      },
      { term: 'ภาพรวมมหภาค', text: 'ติดตามเศรษฐกิจและการเมือง และผลที่มีต่อทิศทางของตลาด' },
      { term: 'ระบบอัตโนมัติ', text: 'เขียนสคริปต์เทรดและ indicator สำหรับ MetaTrader 5 ด้วย MQL5' },
    ],
  },
  education: [
    {
      school: 'สถาบันเทคโนโลยีพระจอมเกล้าเจ้าคุณทหารลาดกระบัง',
      detail: 'วิศวกรรมศาสตรบัณฑิต สาขาวิศวกรรมโทรคมนาคม',
      period: '2019 ถึง 2023',
    },
    {
      school: 'สถาบันเทคโนโลยีพระจอมเกล้าเจ้าคุณทหารลาดกระบัง',
      detail: 'วิชาโท AI และ Deep Learning',
      period: '2019 ถึง 2023',
    },
    {
      school: 'โรงเรียนเบญจมราชรังสฤษฎิ์',
      detail: 'แผนการเรียนวิทยาศาสตร์-คณิตศาสตร์',
      period: '2016 ถึง 2019',
    },
  ],
  activities: [
    'รองประธานนักศึกษา ภาควิชาวิศวกรรมโทรคมนาคม สจล. ปี 2019 ถึง 2023',
    'ติวเตอร์ Physics and Mathematical Academy สจล. ปี 2019 ถึง 2021',
    'เรียน ICT ที่ Huawei ICT Academy',
    'เข้าร่วม DDCamp 5 แบบ onsite',
  ],
  interests: [
    'AIAT MOOC และ Super AI Engineering season 2',
    'KMITL Football Club Academy',
    'ว่ายน้ำ ฟุตบอล บาสเกตบอล และมวยไทย',
  ],
};

export default th;
